import { Link } from 'react-router-dom';

const MOCK_LIVREURS = [
  { id: 1, name: 'Mamadou K.', type: 'Livreur communautaire', distance: '0.3 km', price: '2 500 GNF', rating: '4.9', available: true, vehicle: 'ri-motorbike-line' },
  { id: 2, name: 'Fatoumata D.', type: 'Livreur professionnel', distance: '0.8 km', price: '4 000 GNF', rating: '5.0', available: true, vehicle: 'ri-car-line' },
  { id: 3, name: 'Ibrahim S.', type: 'Livreur communautaire', distance: '1.2 km', price: '1 500 GNF', rating: '4.7', available: false, vehicle: 'ri-bike-line' },
];

interface KeyFeaturesProps {
  setShowCommunityDelivery: (show: boolean) => void;
  setShowRealTimeTracking: (show: boolean) => void;
}

export function KeyFeaturesSection({ setShowCommunityDelivery, setShowRealTimeTracking }: KeyFeaturesProps) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-sm font-semibold text-teal-600 uppercase tracking-wider mb-2">Fonctionnalités clés</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Tout ce dont vous avez besoin</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-start">

          {/* Livraison communautaire */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-community-line text-teal-600 text-lg" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Livraison Communautaire</h3>
                <p className="text-sm text-gray-500">Livreurs disponibles près de vous</p>
              </div>
            </div>

            <div className="space-y-3 mb-6">
              {MOCK_LIVREURS.map(l => (
                <div key={l.id}
                  className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl border border-gray-200
                    hover:border-teal-200 hover:bg-teal-50/30 transition-all">
                  <div className="w-11 h-11 bg-teal-100 rounded-full flex items-center justify-center shrink-0">
                    <i className={`${l.vehicle} text-teal-600`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <p className="font-semibold text-gray-900 text-sm">{l.name}</p>
                      <span className={`w-2 h-2 rounded-full ${l.available ? 'bg-green-400' : 'bg-gray-300'}`} />
                    </div>
                    <p className="text-xs text-gray-500">{l.type} · {l.distance}</p>
                  </div>
                  <div className="text-right shrink-0">
                    <p className="font-bold text-gray-900 text-sm">{l.price}</p>
                    <div className="flex items-center justify-end gap-1">
                      <i className="ri-star-fill text-yellow-400 text-xs" />
                      <span className="text-xs text-gray-500">{l.rating}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex gap-3">
              <button onClick={() => setShowCommunityDelivery(true)}
                className="flex-1 bg-teal-600 hover:bg-teal-700 text-white py-3 rounded-xl
                  font-semibold text-sm transition-colors flex items-center justify-center gap-2">
                <i className="ri-search-line" />
                Trouver un livreur
              </button>
              <Link to="/register/livreur"
                className="px-5 py-3 border-2 border-teal-200 text-teal-700 rounded-xl
                  font-semibold text-sm hover:bg-teal-50 transition-colors whitespace-nowrap">
                Devenir livreur
              </Link>
            </div>
          </div>

          {/* Suivi temps réel */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center">
                <i className="ri-map-pin-line text-orange-600 text-lg" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Suivi en Temps Réel</h3>
                <p className="text-sm text-gray-500">Précision GPS ‹ 50m</p>
              </div>
            </div>

            {/* Carte mock */}
            <div className="relative bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl
              border border-teal-100 h-64 flex items-center justify-center mb-5 overflow-hidden">
              {/* Éléments décoratifs carte */}
              <div className="absolute inset-0 opacity-20">
                {[...Array(6)].map((_, i) => (
                  <div key={i}
                    className="absolute border border-teal-300"
                    style={{
                      left: `${(i % 3) * 33}%`, top: `${Math.floor(i / 3) * 50}%`,
                      width: '34%', height: '52%',
                    }}
                  />
                ))}
              </div>
              {/* Pin livreur animé */}
              <div className="relative text-center z-10">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg shadow-orange-200 animate-pulse">
                  <i className="ri-truck-line text-white text-2xl" />
                </div>
                <div className="bg-white rounded-xl px-4 py-2 shadow-md">
                  <p className="text-sm font-semibold text-gray-900">En route · 8 min</p>
                  <p className="text-xs text-gray-500">1.2 km restants</p>
                </div>
              </div>
            </div>

            {/* Steps du suivi */}
            <div className="space-y-2 mb-5">
              {[
                { label: 'Commande confirmée', done: true },
                { label: 'Colis pris en charge', done: true },
                { label: 'En cours de livraison', done: false, active: true },
                { label: 'Livré', done: false },
              ].map((step, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${step.done ? 'bg-teal-600' : step.active ? 'bg-orange-500 ring-4 ring-orange-100' : 'bg-gray-200'
                    }`}>
                    {step.done && <i className="ri-check-line text-white text-xs" />}
                    {step.active && <div className="w-2 h-2 bg-white rounded-full" />}
                  </div>
                  <span className={`text-sm ${step.done ? 'text-gray-700 font-medium' :
                      step.active ? 'text-orange-600 font-semibold' : 'text-gray-400'
                    }`}>{step.label}</span>
                </div>
              ))}
            </div>

            <button onClick={() => setShowRealTimeTracking(true)}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl
                font-semibold text-sm transition-colors flex items-center justify-center gap-2">
              <i className="ri-map-2-line" />
              Suivre un colis en direct
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default KeyFeaturesSection;
